// src/constants/index.js
// Données de référence HmongHearts

// 18 clans Hmong officiels (ordre alphabétique) + "Autre"
export const FAMILLES = [
  'Chang',
  'Cheng',
  'Chue',
  'Fang',
  'Hang',
  'Her',
  'Khang',
  'Kong',
  'Kue',
  'Lee',
  'Lor',
  'Moua',
  'Pha',
  'Thao',
  'Vang',
  'Vue',
  'Xiong',
  'Yang',
  'Autre',
];

export const GENDERS = [
  { value: 'M', labelKey: 'constants.genders.M' },
  { value: 'F', labelKey: 'constants.genders.F' },
  { value: 'NB', labelKey: 'constants.genders.NB' },
];

export const LOOKING_FOR = [
  { value: 'M', labelKey: 'constants.lookingFor.M' },
  { value: 'F', labelKey: 'constants.lookingFor.F' },
  { value: 'ALL', labelKey: 'constants.lookingFor.ALL' },
];

export const INTENTIONS = [
  { value: 'serious', labelKey: 'constants.intentions.serious' },
  { value: 'casual', labelKey: 'constants.intentions.casual' },
  { value: 'friends', labelKey: 'constants.intentions.friends' },
  { value: 'open', labelKey: 'constants.intentions.open' },
];

export const MOTIVATIONS = [
  { value: 'dating', labelKey: 'constants.motivations.dating' },
  { value: 'events', labelKey: 'constants.motivations.events' },
  { value: 'community', labelKey: 'constants.motivations.community' },
];

export const INTEREST_CATEGORIES = [
  {
    labelKey: 'constants.interestCategories.cultureHmong',
    interests: [
      { value: 'langue-hmong', labelKey: 'constants.interests.langueHmong' },
      { value: 'broderie-couture', labelKey: 'constants.interests.broderieCouture' },
      { value: 'musique-traditionnelle', labelKey: 'constants.interests.musiqueTraditionnelle' },
      { value: 'histoire-hmong', labelKey: 'constants.interests.histoireHmong' },
      { value: 'spiritualite', labelKey: 'constants.interests.spiritualite' },
      { value: 'famille-traditions', labelKey: 'constants.interests.familleTraditions' },
    ],
  },
  {
    labelKey: 'constants.interestCategories.cuisine',
    interests: [
      { value: 'cuisine-hmong', labelKey: 'constants.interests.cuisineHmong' },
      { value: 'pho-soupes', labelKey: 'constants.interests.phoSoupes' },
      { value: 'barbecue-grillades', labelKey: 'constants.interests.barbecueGrillades' },
      { value: 'nems-raviolis', labelKey: 'constants.interests.nemsRaviolis' },
      { value: 'patisserie', labelKey: 'constants.interests.patisserie' },
    ],
  },
  {
    labelKey: 'constants.interestCategories.sportLoisirs',
    interests: [
      { value: 'football', labelKey: 'constants.interests.football' },
      { value: 'volley', labelKey: 'constants.interests.volley' },
      { value: 'badminton', labelKey: 'constants.interests.badminton' },
      { value: 'arts-martiaux', labelKey: 'constants.interests.artsMartiaux' },
      { value: 'randonnee', labelKey: 'constants.interests.randonnee' },
      { value: 'gaming', labelKey: 'constants.interests.gaming' },
      { value: 'karaoke', labelKey: 'constants.interests.karaoke' },
      { value: 'danse', labelKey: 'constants.interests.danse' },
    ],
  },
  {
    labelKey: 'constants.interestCategories.lifestyle',
    interests: [
      { value: 'voyage', labelKey: 'constants.interests.voyage' },
      { value: 'photo', labelKey: 'constants.interests.photo' },
      { value: 'education', labelKey: 'constants.interests.education' },
      { value: 'entrepreneuriat', labelKey: 'constants.interests.entrepreneuriat' },
      { value: 'bien-etre', labelKey: 'constants.interests.bienEtre' },
    ],
  },
];

// Liste aplatie pour validation / lookup
export const INTERESTS = INTEREST_CATEGORIES.flatMap((c) => c.interests);

export const EVENT_CATEGORIES = [
  { value: 'cultural', labelKey: 'constants.eventCategories.cultural' },
  { value: 'culinary', labelKey: 'constants.eventCategories.culinary' },
  { value: 'sports', labelKey: 'constants.eventCategories.sports' },
  { value: 'social', labelKey: 'constants.eventCategories.social' },
  { value: 'educational', labelKey: 'constants.eventCategories.educational' },
  { value: 'online', labelKey: 'constants.eventCategories.online' },
  { value: 'dating', labelKey: 'constants.eventCategories.dating' },
];

// Returns the i18n labelKey for an event category — wrap with t() to display
export const getCategoryLabel = (value) =>
  EVENT_CATEGORIES.find((c) => c.value === value)?.labelKey || value;

export const CATEGORY_COLORS = {
  cultural: 'rose',
  culinary: 'rose',
  sports: 'green',
  social: 'purple',
  educational: 'blue',
  online: 'blue',
  dating: 'rose',
};

export const CATEGORY_GRADIENTS = {
  cultural: 'from-rose-400 to-pink-500',
  culinary: 'from-amber-400 to-orange-500',
  sports: 'from-emerald-400 to-teal-500',
  social: 'from-purple-400 to-violet-500',
  educational: 'from-blue-400 to-indigo-500',
  online: 'from-cyan-400 to-blue-500',
  dating: 'from-pink-400 to-rose-500',
};

// ── Dating enrichi (Phase O.2) ──

export const EDUCATION_LEVELS = [
  { value: 'highschool', labelKey: 'constants.education.highschool' },
  { value: 'bachelor', labelKey: 'constants.education.bachelor' },
  { value: 'master', labelKey: 'constants.education.master' },
  { value: 'phd', labelKey: 'constants.education.phd' },
  { value: 'other', labelKey: 'constants.education.other' },
];

export const LANGUAGES = [
  { value: 'fr', labelKey: 'constants.languages.fr' },
  { value: 'en', labelKey: 'constants.languages.en' },
  { value: 'hmong', labelKey: 'constants.languages.hmong' },
  { value: 'lao', labelKey: 'constants.languages.lao' },
  { value: 'thai', labelKey: 'constants.languages.thai' },
  { value: 'zh', labelKey: 'constants.languages.zh' },
  { value: 'vi', labelKey: 'constants.languages.vi' },
  { value: 'other', labelKey: 'constants.languages.other' },
];

// ── Annonces (Phase G) ──

export const ANNONCE_CATEGORIES = [
  { id: 'commerce', labelKey: 'constants.annonceCategories.commerce' },
  { id: 'services', labelKey: 'constants.annonceCategories.services' },
  { id: 'logement', labelKey: 'constants.annonceCategories.logement' },
  { id: 'emploi', labelKey: 'constants.annonceCategories.emploi' },
  { id: 'divers', labelKey: 'constants.annonceCategories.divers' },
];

export const ANNONCE_MAX_PHOTOS = 5;
export const ANNONCE_MAX_ACTIVE = 5;
export const ANNONCE_DURATION_DAYS = 30;
export const ANNONCE_MAX_DESCRIPTION = 1000;

// Returns the i18n labelKey for an annonce category — wrap with t() to display
export const getAnnonceCategoryLabel = (id) =>
  ANNONCE_CATEGORIES.find((c) => c.id === id)?.labelKey || id;

// ── Analytics GA4 (Phase K.7) ──

export const GA_MEASUREMENT_ID = 'G-K3ZHE02184';

// Bio prompts — array of i18n keys. Stored as keys in Firestore.
// Legacy data (French text) displays as-is via t() fallback.
export const BIO_PROMPTS = [
  'constants.bioPrompts.cultureHmong',
  'constants.bioPrompts.platPrefere',
  'constants.bioPrompts.secret',
  'constants.bioPrompts.weekend',
  'constants.bioPrompts.souvenir',
  'constants.bioPrompts.voyage',
  'constants.bioPrompts.tradition',
  'constants.bioPrompts.talent',
];
